import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const squareOutline: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M8.75-10h-6.5q-.515 0-.89.375c-.243.242-.36.531-.36.875v6.5c0 .344.117.64.36.89.25.243.546.36.89.36h6.5c.344 0 .633-.117.875-.36Q10-1.734 10-2.25v-6.5a1.17 1.17 0 0 0-.375-.875A1.17 1.17 0 0 0 8.75-10M11-8.75v6.5q0 .925-.656 1.594A2.17 2.17 0 0 1 8.75 0h-6.5A2.2 2.2 0 0 1 .656-.656 2.2 2.2 0 0 1 0-2.25v-6.5q0-.937.656-1.594A2.2 2.2 0 0 1 2.25-11h6.5a2.17 2.17 0 0 1 1.594.656Q11-9.687 11-8.75m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "11",
    width: "11",
  }
};
